import { Navigate, useLocation } from 'react-router';
import { getTypeSlug } from '@util/common.js';
import { overlays } from '@data/overlays.js';
import { graphics } from '@data/graphics.js';
import { information } from '@data/information.js';
import { chatbots } from '@data/chatbots.js';
import ListItem from '@components/shared/list-item.jsx';
import { useMetaTags } from 'react-metatags-hook';
import { categories } from '@data/categories.js';
import PageHeader from '@components/layout/page-header.jsx';
import { isTestMode } from '@util/const.js';

export default function ListPageLayout() {
  const location = useLocation();
  const { type } = getTypeSlug(location.pathname);

  let items;

  switch (type) {
    case 'overlays':
      items = Object.values(overlays);
      break;
    case 'graphics':
      items = Object.values(graphics).sort((a, b) => a.order - b.order);
      break;
    case 'information':
      items = Object.values(information).filter((item) => item.show);
      break;
    case 'chatbots':
      items = Object.values(chatbots);
      break;
  }

  const { description, name, pageName } = categories.find(
    (category) => category.type === type
  );

  useMetaTags(
    {
      title: `${pageName || name} | ${isTestMode ? '' : 'St. Jude '}Play Live Tools`,
      description,
      openGraph: {
        description,
      },
    },
    [description, name, pageName]
  );

  if (!items || !items.length) {
    return <Navigate to={'/'} replace={true} />;
  }

  items = items.sort((a, b) => {
    if (a.isNew || a.isUpdated) return -1;
    else if (b.isNew || b.isUpdated) return -1;
    else return a.name.localeCompare(b.name);
  });

  const link = { title: pageName || name };
  const itemCards = items.map((item) => <ListItem key={item.link} {...item} />);

  return (
    <div className="h-full w-full overflow-x-hidden flex flex-col items-center">
      <div className="flex flex-col max-w-screen-2xl w-full overflow-x-hidden pt-5 pb-10">
        <PageHeader
          className="ml-6 mb-2"
          name={name}
          description={description}
          links={[link]}
        />
        <div className="join join-vertical mx-6  flex-grow">{itemCards}</div>
      </div>
    </div>
  );
}
